var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content main-content"},[_c('div',{staticClass:"container container-fluid"},[_c('transition-page',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }